export const environment = {
  production: true,
  appBaseUrl: 'https://api.friday.life',
  envName: 'prod'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts